import * as React from "react";
import useEnsureUserProfile from "@/hooks/use-ensure-user-profile";
// DashboardHeaderSection now self-loads user profile from global store.

export interface DashboardHeaderSectionProps {
  /** Provide mobile action elements (rendered within mobile layout area). Omit to hide. */
  actionsMobile?: React.ReactNode;
  /** Provide desktop action elements (rendered within desktop layout area). Omit to hide. */
  actionsDesktop?: React.ReactNode;
  className?: string;
}

/** DashboardHeaderSection – presentational header with optional injected action areas. */
const DASHBOARD_TAGLINE =
  "One platform. Real-time data. Smarter aviation decisions";

export const DashboardHeaderSection: React.FC<DashboardHeaderSectionProps> = ({
  actionsMobile,
  actionsDesktop,
  className = "",
}) => {
  const { userProfile, isLoading } = useEnsureUserProfile();
  const roles = (userProfile?.roles || (isLoading ? "Loading" : "User"))
    .split(",")
    .map((r: string) => r.trim())
    .filter(Boolean);

  return (
    <section className={`aero:min-h-24 ${className}`}>
      <div className="aero:flex aero:flex-col aero:gap-2">
        <div className="aero:flex aero:items-center aero:gap-2 aero:flex-wrap">
          {roles.map((role: string, idx: number) => (
            <div
              key={idx}
              className="aero:bg-blue-800 aero:rounded-full aero:w-fit aero:text-white aero:text-sm aero:font-medium aero:px-2.5 aero:py-1"
            >
              {role}
            </div>
          ))}
        </div>
        <div className="aero:flex aero:item-end aero:justify-between aero:w-full">
          <div className="aero:flex aero:flex-col aero:gap-1">
            <h1 className="aero:text-2xl aero:leading-9 aero:font-bold aero:text-black">
              Welcome back,{" "}
              <span className="underline-swash-behind">
                {isLoading ? "Loading..." : userProfile?.fullName || "Guest"}
              </span>
            </h1>
            <p className="aero:text-neutral-500 aero:text-base font-normal leading-5">
              {DASHBOARD_TAGLINE}
            </p>
            {/* Mobile actions */}
            {actionsMobile}
          </div>
          {/* Desktop actions */}
          {actionsDesktop}
        </div>
      </div>
    </section>
  );
};

export default DashboardHeaderSection;
